export default "__VITE_ASSET__Ch5Sc9kG__"